import {useContext} from "react";
import {selectedParcelsContext} from "../providers/SelectedParcelsProvider";

export function useSelectedParcels() {
    return useContext(selectedParcelsContext);
}